import { SupportFieldType } from '@app/features/apply-react-signing/components/FieldSetupStep/ParticipantFieldStatusBoard';

// 서명 요청하기
// https://github.com/modusign/modusign-client/blob/3b737548ec252d26868a7a09007209e64f90f5ad/app/src/routes/Editor/OthersRequire/Position/index.tsx
export const supportedFieldsEditorOthersRequirePositionPage: SupportFieldType[] = [
  'SIGNATURE',
  'TEXT',
  'CHECKBOX_GROUP',
  'DROPDOWN',
  'NAME',
  'COMPANY_NAME',
  'ADDRESS',
  'DATE',
  'SIGNING_DATE',
];

// 템플릿 생성하기
// https://github.com/modusign/modusign-client/blob/aa0476d8ea24b8247cf7366eca6d656a0ef2d8c1/app/src/features/template/components/TemplateSetupPages/TemplateFieldSetupPage/index.tsx
export const supportedFieldsTemplateFieldSetupPage: SupportFieldType[] = [
  'SIGNATURE',
  'TEXT',
  'CHECKBOX_GROUP',
  'DROPDOWN',
  'NAME',
  'COMPANY_NAME',
  'ADDRESS',
  'DATE',
  'SIGNING_DATE',
];

// 템플릿 수정하기
// https://github.com/modusign/modusign-client/blob/aa0476d8ea24b8247cf7366eca6d656a0ef2d8c1/app/src/features/template/components/TemplateEditPages/TemplateFieldEditPage/index.tsx
export const supportedFieldsTemplateFieldEditPage: SupportFieldType[] = [
  'SIGNATURE',
  'TEXT',
  'CHECKBOX_GROUP',
  'DROPDOWN',
  'NAME',
  'COMPANY_NAME',
  'ADDRESS',
  'DATE',
  'SIGNING_DATE',
];

// 대량전송 템플릿 확인하기
// https://github.com/modusign/modusign-client/blob/3b737548ec252d26868a7a09007209e64f90f5ad/app/src/containers/BulkRequestTemplateFieldsInfo/index.tsx
export const supportedFieldsBulkRequestTemplateFieldsInfo: SupportFieldType[] = [
  'SIGNATURE',
  'TEXT',
  'CHECKBOX_GROUP',
  'DROPDOWN',
  'NAME',
  'COMPANY_NAME',
  'ADDRESS',
  'DATE',
  'SIGNING_DATE',
];

// 내부결제 미리보기
// https://github.com/modusign/modusign-client/blob/aa0476d8ea24b8247cf7366eca6d656a0ef2d8c1/app/src/features/approval/approvalPreview/components/ApprovalPreviewTemplateFieldsInfo/index.tsx
export const supportedFieldsApprovalPreviewTemplateFieldsInfo: SupportFieldType[] = [
  'SIGNATURE',
  'TEXT',
  'CHECKBOX_GROUP',
  'DROPDOWN',
  'NAME',
  'COMPANY_NAME',
  'ADDRESS',
  'DATE',
  'SIGNING_DATE',
];

// 링크서명 생성하기 필드 페이지
// https://github.com/modusign/modusign-client/blob/aa0476d8ea24b8247cf7366eca6d656a0ef2d8c1/app/src/features/contractLink/contractLinkCreate/components/ContractLinkCreateFieldSetupContent/index.tsx
export const supportedFieldsContractLinkCreateFieldSetupContent: SupportFieldType[] = [
  'SIGNATURE',
  'TEXT',
  'CHECKBOX_GROUP',
  'DROPDOWN',
  'NAME',
  'COMPANY_NAME',
  'ADDRESS',
  'DATE',
  'SIGNING_DATE',
];

// 링크서명 템플릿 확인하기
// https://github.com/modusign/modusign-client/blob/aa0476d8ea24b8247cf7366eca6d656a0ef2d8c1/app/src/features/contractLink/contractLinkManagement/components/ContractLinkTemplateFieldsInfo/index.tsx
export const supportedFieldsContractLinkTemplateFieldsInfo: SupportFieldType[] = [
  'SIGNATURE',
  'TEXT',
  'CHECKBOX_GROUP',
  'DROPDOWN',
  'NAME',
  'COMPANY_NAME',
  'ADDRESS',
  'DATE',
  'SIGNING_DATE',
];
